// cart-info
window.initCartInfo = () => {
	$('.cart-card__info').each(function(){
		$(this).find('.cart-card__info-title').off('click', openFunction);
		$(this).find('.cart-card__info-title').on('click', openFunction);
	});
}

function openFunction() {
	$(this).toggleClass('js__open');
	$(this).siblings('.cart-card__info-cont').slideToggle();
}